export type Task_toolApiHandle =
  | `/settings`
  | `/settings/${string}`
  | `/tasks`
  | `/tasks/${string}`
  | `/tasks/${string}/revoke`
  | `/tasks/bulk_revoke`
  | `/tasks/${string}/abort`
  | `/workers/tasks`
  | `/queues`
  | `/queues/${string}/contents`
  | `/`;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface Task_toolInstance extends AxiosInstance {
  get<T = any, R = AxiosResponse<T>, P extends string = Task_toolApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  delete<T = any, R = AxiosResponse<T>, P extends string = Task_toolApiHandle>(
    url: P,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  post<T = any, R = AxiosResponse<T>, P extends string = Task_toolApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
  put<T = any, R = AxiosResponse<T>, P extends string = Task_toolApiHandle>(
    url: P,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<R>;
}

import axios from 'axios';
import { AXIOS_NO_CACHE_HEADERS } from '@/shared/api/no-cache-headers';
import i18n from '@/shared/config/i18n';

export const taskToolInstance = axios.create({
  baseURL: '/api/task_tool/v3',
  headers: AXIOS_NO_CACHE_HEADERS,
}) as Task_toolInstance;

i18n.on('languageChanged', (lng) => {
  taskToolInstance.defaults.headers.common['Accept-Language'] = lng;
});